import React, { useState, useEffect, useReducer, useContext } from 'react';
import { UserContext } from '../AppContext';
import { useCookies } from 'react-cookie';

import { auth, db, DB_TYPE } from '../Firestore';

export const UserReducer = () => {
    const oReducer = useReducer(userAction, { user: null });
    return oReducer;
}
const userAction = (state, action) => {
    let newState = { ...state };
    switch (action.type) {
        case 'SET':
            newState.user = action.data;
            newState.openLogin = false;
            if (newState.authenCallBack)
                newState.authenCallBack();
            return newState;
        case 'REQUIRE_AUTHEN':
            newState.openLogin = true;
            newState.authenCallBack = action.data;
            return newState;
        case 'CLOSE_LOGIN':
            newState.openLogin = false;
            return newState;
        case 'SET_INFO':
            newState.user.info = action.data;
            return newState;
        default: return state;
    }
}

export const useUser = () => {
    const userContext = useContext(UserContext);
    const [state, dispacth] = userContext;
    const [cookies, setCookie, removeCookie] = useCookies(['user']);

    const setUser = async (user) =>{
        //const res = await 
        dispacth({type:'SET', data: user})
    }

    const login = async (email, pass) => {
        let user = null;
        let success = false;
        let errorMessage = null;
        //TBD: login firestore
        await auth.signInWithEmailAndPassword(email, pass).then((userCredential) => {
            // Signed in
            success=true;
            user = userCredential.user;
            console.log("USER: ", user)
            dispacth({type:'SET', data: user})
            setCookie('user', user);
            return user;
            // ...
          }).catch(function (error) {
            // Handle Errors here.
            console.log("Error: ", error);
            success = false;
            errorMessage=error;
            // ...
        });
        return {
            success,errorMessage,user
        };
    }

    const requireAuthen = (callback) => {
        dispacth({type:'REQUIRE_AUTHEN', data: callback})
    }

    const logOut = async ()=>{
        await auth.signOut().then(function() {
        // Sign-out successful.
        console.log("Sign-out successful");
        removeCookie('user');
        dispacth({type:'SET', data:null});
        requireAuthen()
      }).catch(function(error) {
        // An error happened.
        console.log("Sign-out error: ", error);
      });
    }

    return {
        user:state.user,
        openLogin:state.openLogin,
        login, requireAuthen,logOut, setUser
    }
}